import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OpportunitiesComponent } from './components/opportunities/opportunities.component';
import { APP_BASE_HREF } from '@angular/common';

const routes: Routes = [
  {path: '',  component: OpportunitiesComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [
  ]
})
export class OpportunityListRoutingModule { }
